import { resolveCloudScreenshotUrl } from "../../../../lib/utils";

const CUSTOM_SCREENSHOTS_BASE = "instructions/screenshots";
const cloudScreenshot = (relativePath) => resolveCloudScreenshotUrl(`${CUSTOM_SCREENSHOTS_BASE}/${relativePath}`);

const BW_KEY_STYLE = {
 color: "#FFFFFF",
 textStroke: "0.18vw #000000",
 textShadow: "0 0 0.12vw #000000",
};

export const MISSION_THREE_SCREENSHOT_LAYOUT_BY_PAGE = {
 m301: {
  src: cloudScreenshot(`screenshots_m3/instructions 3.01.svg`),
  title: "NEXT MISSION",
  leftPercent: 50,
  topPercent: 10,
  widthPercent: 42,
  maxWidthPercent: 48,
  titleWidthPercent: 28,
  titleLeftPercent: 50,
  titleTopVw: -0.25,
 },
 m302: {
  src: cloudScreenshot(`screenshots_m3/instructions 3.02.svg`),
  title: "Spy Support (1)",
  leftPercent: 57.3,
  topPercent: 10,
  widthPercent: 58.5,
  maxWidthPercent: 58.5,
  details: [
   { left: 40.6, top: 53.5, key: "KeyZ", fontSizeVw: 0.64 },
   { left: 42.5, top: 53.5, key: "KeyS", fontSizeVw: 0.74, ...BW_KEY_STYLE },
   { left: 44.8, top: 53.5, key: "KeyD", fontSizeVw: 0.74 },
   { left: 47.85, top: 53.5, key: "KeyF", fontSizeVw: 0.74 },
   { left: 53, top: 53.5, key: "KeyK", fontSizeVw: 0.74 },
   { left: 55.6, top: 53.5, key: "KeyL", fontSizeVw: 0.74 },
   { left: 58.2, top: 53.5, key: "Semicolon", fontSizeVw: 0.74, ...BW_KEY_STYLE },
   { left: 60.2, top: 53.5, key: "Slash", fontSizeVw: 0.64 },
  ],
  titleWidthPercent: 28,
  titleLeftPercent: 41,
  titleTopVw: -0.25,
 },
 m303: {
  src: cloudScreenshot(`screenshots_m3/instructions 3.03.svg`),
  title: "Spy Support (2)",
  leftPercent: 60,
  topPercent: 10,
  widthPercent: 64,
  maxWidthPercent: 64,
  details: [
   { left: 40.6, top: 53.5, key: "KeyZ", fontSizeVw: 0.64 },
   { left: 42.5, top: 53.5, key: "KeyS", fontSizeVw: 0.74, ...BW_KEY_STYLE },
   { left: 44.8, top: 53.5, key: "KeyD", fontSizeVw: 0.74 },
   { left: 47.85, top: 53.5, key: "KeyF", fontSizeVw: 0.74 },
   { left: 53, top: 53.5, key: "KeyK", fontSizeVw: 0.74 },
   { left: 55.6, top: 53.5, key: "KeyL", fontSizeVw: 0.74 },
   { left: 58.2, top: 53.5, key: "Semicolon", fontSizeVw: 0.74, ...BW_KEY_STYLE },
   { left: 60.2, top: 53.5, key: "Slash", fontSizeVw: 0.64 },
  ],
  titleWidthPercent: 28,
  titleLeftPercent: 41,
  titleTopVw: -0.25,
 },
 m304: {
  src: cloudScreenshot(`screenshots_m3/instructions 3.04.svg`),
  title: "Alternative Option",
  leftPercent: 50.5,
  topPercent: 10,
  widthPercent: 45,
  maxWidthPercent: 48,
  titleWidthPercent: 28,
  titleLeftPercent: 41,
  titleTopVw: -0.25,
 },
 m305: {
  src: cloudScreenshot(`screenshots_m3/instructions 3.05.svg`),
  title: "Bombs",
  leftPercent: 40.8,
  topPercent: 10,
  widthPercent: 64,
  maxWidthPercent: 64,
  titleWidthPercent: 28,
  titleLeftPercent: 41,
  titleTopVw: -0.25,
 },
 m306: {
  src: cloudScreenshot(`screenshots_m3/instructions 3.06.svg`),
  title: "Risk Signal",
  leftPercent: 60,
  topPercent: 10,
  widthPercent: 64,
  maxWidthPercent: 64,
  titleWidthPercent: 28,
  titleLeftPercent: 41,
  titleTopVw: -0.25,
 },
 m307: {
  src: cloudScreenshot(`screenshots_shared/instructions 0.15 1.09 3.07.svg`),
  title: "Game Controller",
  leftPercent: 50,
  topPercent: 10,
  widthPercent: 45,
  maxWidthPercent: 45,
  details: [
   { left: 39.1, top: 39.9, key: "KeyZ", fontSizeVw: 1.22 },
   { left: 40.3, top: 35, key: "KeyS", fontSizeVw: 1.22 },
   { left: 42.8, top: 35, key: "KeyD", fontSizeVw: 1.22 },
   { left: 45.1, top: 35, key: "KeyF", fontSizeVw: 1.22 },
   { left: 54.9, top: 35, key: "KeyK", fontSizeVw: 1.22 },
   { left: 57.3, top: 35, key: "KeyL", fontSizeVw: 1.22 },
   { left: 59.8, top: 35, key: "Semicolon", fontSizeVw: 1.22 },
   { left: 60.96, top: 39.9, key: "Slash", fontSizeVw: 1.22 },
  ],
  titleWidthPercent: 28,
  titleLeftPercent: 50,
  titleTopVw: -0.25,
 },
 m308: {
  src: cloudScreenshot(`screenshots_m3/instructions 3.08.svg`),
  title: "Ready to Play",
  leftPercent: 50,
  topPercent: 10,
  widthPercent: 45,
  maxWidthPercent: 45,
  titleWidthPercent: 28,
  titleLeftPercent: 50,
  titleTopVw: -0.25,
 },
};
